module.exports = "<symbol id=\"tt-icon-logout\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M18.23 10.87H5.77v2.26h12.46v3.4L23.89 12l-5.66-4.53zm-3.4 4.53h-2.26v4.53H2.37V4.07h10.2V8.6h2.26V1.81H.11v20.38h14.72z\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/logout.svg
// module id = 208
// module chunks = 9